import { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const services = [
  {
    id: 'fences',
    title: 'Fencing',
    headline: 'Expert Fence Installation Across Florida',
    description: "Dippel's Outdoor Services installs premium fences across Ormond Beach, Daytona Beach, Port Orange, and throughout Volusia County. Whether you need privacy, security, or curb appeal, we offer a full range of materials and styles.",
    image: 'https://public.readdy.ai/ai/img_res/5072d58160aec2742312d409f776b0df.jpg',
    items: [
      { name: 'Vinyl Fence Installation', desc: 'Durable, low-maintenance vinyl fences in a variety of colors and styles. Perfect for Florida\'s climate.' },
      { name: 'Wood Fence Installation', desc: 'Classic wood fences crafted with premium lumber for natural beauty and lasting strength.' },
      { name: 'Chain Link Fence Installation', desc: 'Affordable and secure chain link fencing ideal for residential and commercial properties.' },
      { name: 'Aluminum Fence Installation', desc: 'Elegant and rust-resistant aluminum fences — ideal for pool enclosures and decorative borders.' },
    ],
    icon: 'ri-home-4-line',
    color: 'bg-forest/10 text-forest',
  },
  {
    id: 'pavers',
    title: 'Pavers',
    headline: 'Custom Paver Systems Built to Last',
    description: 'Transform your driveway, patio, pool deck, or walkway with beautifully installed pavers by Dippel\'s. We design, source, and install paver systems that stand up to Florida weather while enhancing your property value.',
    image: 'https://readdy.ai/api/search-image?query=luxury%20natural%20stone%20paver%20patio%20outdoor%20living%20space%20Florida%20high-end%20residential%20elegant%20pool%20deck%20outdoor%20furniture%20warm%20afternoon%20golden%20light%20premium%20craftsmanship%20sophisticated&width=900&height=700&seq=dippels-pg-pavers&orientation=landscape',
    items: [
      { name: 'Driveway Pavers', desc: 'Stunning, durable driveway paver systems that boost curb appeal and withstand heavy use.' },
      { name: 'Patio Pavers', desc: 'Custom patio designs that create the perfect outdoor living space for entertaining and relaxing.' },
      { name: 'Pool Deck Pavers', desc: 'Non-slip, heat-resistant pool deck pavers that are both beautiful and safe.' },
      { name: 'Steps & Coping', desc: 'Precision-crafted steps and coping that add architectural elegance to any outdoor space.' },
      { name: 'Paver Repairs', desc: 'Expert paver repair and restoration to bring aging surfaces back to like-new condition.' },
      { name: 'Walkway Pavers', desc: 'Inviting walkway designs that guide guests through your property in style.' },
    ],
    icon: 'ri-layout-grid-line',
    color: 'bg-gold/10 text-gold-dark',
  },
  {
    id: 'landscape',
    title: 'Landscape Installation',
    headline: 'Lush Florida Landscapes Designed by Experts',
    description: "With a degree in landscaping, Dippel's owner personally oversees every installation. From Palm Coast sod to New Smyrna Beach planting beds, we create thriving, low-maintenance outdoor environments tailored to Florida's unique soil and climate.",
    image: 'https://readdy.ai/api/search-image?query=luxury%20residential%20landscape%20installation%20Florida%20lush%20tropical%20plants%20manicured%20emerald%20sod%20lawn%20premium%20planting%20beds%20neat%20mulch%20professional%20landscaping%20vibrant%20green%20upscale%20home%20beautiful%20curb%20appeal&width=900&height=700&seq=dippels-pg-landscape&orientation=landscape',
    items: [
      { name: 'Sod Installation', desc: 'Fresh, professionally installed sod that creates an instant lush lawn across any property size.' },
      { name: 'Planting & Beds', desc: 'Custom planting beds filled with Florida-appropriate plants, shrubs, and tropical species.' },
      { name: 'Mulch & Rock', desc: 'Decorative mulch and rock ground cover that reduces maintenance and enhances appearance.' },
      { name: 'Edging & Borders', desc: 'Clean, precise edging and landscape borders that give your property a polished, finished look.' },
      { name: 'Grading & Soil Prep', desc: 'Proper grading and soil preparation that ensures healthy plant growth and proper drainage.' },
    ],
    icon: 'ri-plant-line',
    color: 'bg-forest/10 text-forest',
  },
  {
    id: 'lighting',
    title: 'Landscape Lighting & Irrigation',
    headline: 'Illuminate Your Property. Conserve Your Water.',
    description: "Dippel's Outdoor Services designs and installs professional outdoor lighting and irrigation systems across all our Florida service areas. Enhance your property's nighttime beauty and automate your watering for a healthier, greener landscape.",
    image: 'https://readdy.ai/api/search-image?query=elegant%20outdoor%20landscape%20lighting%20luxury%20Florida%20home%20dusk%20pathway%20lights%20uplighting%20palm%20trees%20warm%20amber%20golden%20glow%20dramatic%20nighttime%20garden%20scene%20premium%20outdoor%20lighting%20design%20sophisticated%20cinematic&width=900&height=700&seq=dippels-pg-lighting&orientation=landscape',
    items: [
      { name: 'Path Lighting', desc: 'Elegant path lighting that guides guests safely while highlighting your landscape\'s beauty.' },
      { name: 'Accent & Uplighting', desc: 'Dramatic uplighting that showcases trees, architectural features, and focal points.' },
      { name: 'Downlighting', desc: 'Soft downlighting from trees and structures for a natural, moonlit ambiance.' },
      { name: 'Deck & Step Lighting', desc: 'Safe, attractive lighting integrated into decks, steps, and outdoor structures.' },
      { name: 'Sprinklers & Irrigation', desc: 'Smart sprinkler systems programmed for maximum efficiency and lawn health in Florida.' },
      { name: 'Drip Systems', desc: 'Precision drip irrigation for planting beds, gardens, and drought-sensitive landscapes.' },
    ],
    icon: 'ri-sun-line',
    color: 'bg-gold/10 text-gold-dark',
  },
  {
    id: 'sheds',
    title: 'Sheds',
    headline: 'Custom Sheds Built for Florida Properties',
    description: 'Need extra storage, a dedicated workspace, or a garden retreat? Dippel\'s builds custom sheds designed to complement your property and withstand Florida\'s weather year-round. From Edgewater garages to Port Orange garden sheds — we deliver quality.',
    image: 'https://readdy.ai/api/search-image?query=premium%20custom%20shed%20storage%20building%20luxury%20backyard%20Florida%20property%20high-end%20elegant%20design%20manicured%20lawn%20professional%20quality%20construction%20beautiful%20landscaping%20upscale%20residential%20clean%20lines&width=900&height=700&seq=dippels-pg-sheds&orientation=landscape',
    items: [
      { name: 'Storage Sheds', desc: 'Spacious, durable storage sheds to keep your tools, equipment, and belongings organized.' },
      { name: 'Garden Sheds', desc: 'Charming garden sheds designed to blend beautifully with your landscape.' },
      { name: 'Workshop Sheds', desc: 'Fully functional workshop sheds with ample space for projects and equipment.' },
      { name: 'Utility Sheds', desc: 'Heavy-duty utility sheds built for demanding storage and work environments.' },
      { name: 'Metal Sheds', desc: 'Long-lasting metal sheds that resist Florida weather, pests, and wear over time.' },
    ],
    icon: 'ri-store-2-line',
    color: 'bg-forest/10 text-forest',
  },
];

export default function ServicesPage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 100);
    }
  }, [location]);

  return (
    <div className="min-h-screen font-sans">
      <Navbar />
      <main>
        {/* Page Hero */}
        <section className="relative overflow-hidden" style={{ minHeight: '460px' }}>
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=luxury%20outdoor%20services%20Florida%20premium%20landscaping%20fencing%20pavers%20lighting%20cinematic%20aerial%20view%20upscale%20residential%20backyard%20warm%20golden%20light%20elegant&width=1920&height=700&seq=dippels-svcs-hero&orientation=landscape"
              alt="Dippel's Outdoor Services Florida — all services"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/65 to-black/40"></div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
          </div>
          <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-transparent via-gold to-transparent opacity-60"></div>

          <div className="relative z-10 max-w-4xl mx-auto px-6 py-32">
            <div className="flex items-center gap-3 mb-5">
              <div className="h-px w-10 bg-gold"></div>
              <span className="text-gold text-[11px] font-semibold tracking-[0.28em] uppercase">Our Services</span>
            </div>
            <h1 className="font-serif text-white font-bold leading-tight mb-5" style={{ fontSize: 'clamp(36px, 4vw, 56px)' }}>
              Outdoor Services Built<br />
              <em className="text-gold not-italic">for Florida Living</em>
            </h1>
            <p className="text-white/60 text-base max-w-xl leading-relaxed mb-8">
              Fencing, Pavers, Landscape Installation, Lighting, Irrigation &amp; Sheds — delivered with expert craftsmanship across Volusia and Flagler County.
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 bg-gold text-charcoal font-bold px-8 py-4 rounded-full hover:bg-gold-light transition-colors whitespace-nowrap"
            >
              <i className="ri-pencil-ruler-2-line"></i>
              Request a Design Consultation
            </Link>
          </div>
        </section>

        {/* Service Nav */}
        <div className="bg-stone border-b border-stone-dark sticky top-0 z-30">
          <div className="max-w-7xl mx-auto px-6 flex overflow-x-auto gap-1 py-3 no-scrollbar">
            {services.map((s) => (
              <a
                key={s.id}
                href={`#${s.id}`}
                className="flex-shrink-0 px-5 py-2 rounded-full text-sm font-medium text-charcoal hover:bg-forest hover:text-white transition-colors whitespace-nowrap"
              >
                {s.title}
              </a>
            ))}
          </div>
        </div>

        {/* Service Sections */}
        {services.map((svc, idx) => (
          <section
            key={svc.id}
            id={svc.id}
            className={`py-20 px-6 ${idx % 2 === 0 ? 'bg-white' : 'bg-stone'}`}
          >
            <div className="max-w-7xl mx-auto">
              <div className={`grid lg:grid-cols-2 gap-14 items-center ${idx % 2 !== 0 ? 'lg:flex-row-reverse' : ''}`}>
                {/* Image */}
                <div className={`${idx % 2 !== 0 ? 'lg:order-2' : ''} w-full h-96 rounded-2xl overflow-hidden`}>
                  <img
                    src={svc.image}
                    alt={`${svc.title} - Dippel's Outdoor Services Florida`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                {/* Content */}
                <div className={idx % 2 !== 0 ? 'lg:order-1' : ''}>
                  <div className={`inline-flex items-center gap-2 ${svc.color} px-3 py-1.5 rounded-full mb-4`}>
                    <i className={svc.icon}></i>
                    <span className="text-xs font-semibold uppercase tracking-wider">{svc.title}</span>
                  </div>
                  <h2 className="font-serif text-3xl md:text-4xl text-charcoal font-bold mb-4">{svc.headline}</h2>
                  <p className="text-charcoal-muted text-sm leading-relaxed mb-7">{svc.description}</p>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-7">
                    {svc.items.map((item) => (
                      <div key={item.name} className="bg-white rounded-xl p-4 border border-stone-dark">
                        <p className="font-semibold text-charcoal text-sm mb-1 flex items-center gap-1.5">
                          <i className="ri-checkbox-circle-fill text-forest text-base"></i>
                          {item.name}
                        </p>
                        <p className="text-charcoal-muted text-xs leading-relaxed">{item.desc}</p>
                      </div>
                    ))}
                  </div>
                  <Link
                    to="/contact"
                    className="inline-flex items-center gap-2 bg-forest text-white font-semibold px-7 py-3 rounded-full hover:bg-forest-light transition-colors whitespace-nowrap"
                  >
                    Get a Quote for {svc.title}
                  </Link>
                </div>
              </div>
            </div>
          </section>
        ))}

        {/* Bottom CTA */}
        <section className="bg-charcoal py-16 px-6 text-center">
          <div className="max-w-2xl mx-auto">
            <h2 className="font-serif text-3xl text-white font-bold mb-4">Ready to Get Started?</h2>
            <p className="text-white/60 mb-8">Call Dippel's Outdoor Services today for a free estimate on any of our outdoor services across Florida's east coast.</p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <Link to="/contact" className="bg-gold text-charcoal font-bold px-8 py-4 rounded-full hover:bg-gold-light transition-colors whitespace-nowrap">
                Request Free Estimate
              </Link>
              <a href="tel:3863014399" className="border-2 border-white/30 text-white font-semibold px-8 py-4 rounded-full hover:border-white transition-colors whitespace-nowrap">
                Call (386) 301-4399
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
